let currentUrl = window.location.href
let url = ''
currentUrl = currentUrl.substring(currentUrl.indexOf('://') + 3)
url = url.substring(0, currentUrl.indexOf('/'))

export const API = `${url}/ncoefs_api/public/api/`
export const WEB = `${url}/ncoefs_api/public/`
